"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Fehlerkonsolen-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCErrorConsole
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCErrorConsole} options.module Modul-Instanz
 * @param {Object} options.widget Panel-Widget-Konfiguration
 */
gc.gis.module.GCErrorConsole.Panel = function( options )
{
    gc.gis.assert.isSet( options );
    gc.gis.assert.isSet( options.widget );
    gc.gis.widget.GCPanel.call( this, options.widget );

    gc.gis.assert.isInstance( options.module, gc.gis.module.GCErrorConsole );

    this.module  = options.module;
    this.element = this._render();

    this.element_empty_message = jQuery('<p>', {
        'class': 'gc-empty',
        html: '<em>Keine Meldungen</em>'
    });
    this.element_list = jQuery('<ul>', {
        'class': 'gc-message-list'
    });
    this.element_list.hide();

    this.element_content
        .append( this.element_empty_message )
        .append( this.element_list );
    this.element.append( this.element_content );
};
gc.gis.module.GCErrorConsole.Panel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );

/**
 * Callback, wenn eine Meldung abgesetzt wurde.
 *
 * @public
 * @method
 *
 * @param {gc.gis.log.GCLogEvent} evt
 */
gc.gis.module.GCErrorConsole.Panel.prototype.onMessageLogged = function( evt )
{
    var self = this;

    // rendern
    var li = this._renderMessage( evt );

    // hinzufügen
    this.element_list.append( li );

    // anzeigen
    this.element_empty_message.hide('blind');
    this.element_list.show('blind', {
        complete: function() {
            // hin scrollen
            self.element_content.animate({
                // scrollTop: li.offset().top
                scrollTop: self.element_content.prop('scrollHeight') - self.element_content.height()
            }, 400 );
        }
    });
};

/**
 * Entfernt alle gerenderten Meldungen.
 *
 * @public
 * @method
 */
gc.gis.module.GCErrorConsole.Panel.prototype.clear = function()
{
    var self = this;

    this.element_empty_message.show('blind');
    this.element_list.hide('blind', {
        complete: function() {
            self.element_list.children().remove();
        }
    });
};

/**
 * Zeigt Meldungen eines bestimmten Levels an.
 *
 * @public
 * @method
 *
 * @param {gc.gis.log.GCLogLevel} level
 */
gc.gis.module.GCErrorConsole.Panel.prototype.showLevel = function( level )
{
    this.element_list.find('.gc-message.gc-'+ level ).show('blind');
};

/**
 * Versteckt Meldungen eines bestimmten Levels.
 *
 * @public
 * @method
 *
 * @param {gc.gis.log.GCLogLevel} level
 */
gc.gis.module.GCErrorConsole.Panel.prototype.hideLevel = function( level )
{
    this.element_list.find('.gc-message.gc-'+ level ).hide('blind');
};

/**
 * Rendert eine Log-Meldung.
 *
 * @protected
 * @method
 *
 * @param {gc.gis.log.GCLogEvent} evt
 */
gc.gis.module.GCErrorConsole.Panel.prototype._renderMessage = function( evt )
{
    gc.gis.assert.isSet( evt );

    var self = this;

    // Container
    var alert_type = 'info';
    switch( evt.level )
    {
        case gc.gis.log.GCLogLevel.ERROR:
            alert_type = 'danger';
            break;
        case gc.gis.log.GCLogLevel.WARNING:
            alert_type = 'warning';
            break;
        case gc.gis.log.GCLogLevel.INFO:
            alert_type = 'success';
            break;
    }
    var element_message = jQuery('<li>', {
        'class': 'alert alert-'+ alert_type +' gc-message gc-'+ evt.level
    });

    // Label
    var d = new Date( evt.time );
    var str_hr = d.getHours()   > 9 ? d.getHours()   : '0'+ d.getHours();
    var str_mn = d.getMinutes() > 9 ? d.getMinutes() : '0'+ d.getMinutes();
    var str_sc = d.getSeconds() > 9 ? d.getSeconds() : '0'+ d.getSeconds();

    var element_label = jQuery('<div>', {
        'class': 'gc-message-content'
    });
    element_label.append( jQuery('<span>', {
        'class': 'gc-message-time',
        text: str_hr +':'+ str_mn +':'+ str_sc
    }) );
    element_label.append(' ');
    element_label.append( jQuery('<span>', {
        'class': 'gc-message-text',
        text: evt.message ? evt.message : evt
    }) );
    element_message.append( element_label );

    // ggf. Stacktrace rendern
    if( evt.message.stack )
    {
        var element_stack = jQuery('<ol>', {
            'class': 'gc-message-stack'
        });

        var stack = evt.message.stack.split('\n');
        for( var i=0; i<stack.length; i++ )
        {
            if( stack[i] )
            {
                element_stack.append( jQuery('<li>',{
                    text: stack[i]
                }) );
            }
        }

        element_label.on('click', function() {
            element_stack.toggle('blind', {
                complete: function() {
                    // beim Aufklappen hinscrollen
                    if( element_stack.is(':visible') )
                    {
                        self.element_content.animate({
                            scrollTop: self.element_content.scrollTop()
                            - self.element_content.offset().top
                            + element_message.offset().top
                        });
                    }
                }
            });
        });
        element_stack.hide();
        element_message.append( element_stack );
        element_message.addClass('gc-expandable');
    }

    if( !self.module.isLevelEnabled( evt.level ) )
    {
        element_message.hide();
    }

    return element_message;
};
